import { createFeatureSelector, createSelector } from '@ngrx/store';

import { HttpError } from 'ish-core/models/http-error/http-error.model';

export interface SalesRepState {
  loading: boolean;
  error?: HttpError;
}

export const getSalesRepState = createFeatureSelector<SalesRepState>('salesRep');

export const getSalesRepLoading = createSelector(getSalesRepState, state => state.loading);
